import { LazyAppModals } from "@faire/retailer-visitor-shared/components/App/AppModals/index";
import { preload } from "@faire/retailer-visitor-shared/lib/lazyPreload_DO_NOT_RENAME/__internal__/preload";

const preloadAppModals = () => {
  preload(LazyAppModals);
};

export default preloadAppModals;
